import { useMemo } from 'react';
import { useSynchronizerStatus } from 'tinybase/ui-react';

import { useAppStore } from '../../store/app/appStore';
import { useTinybaseStore } from '../../store/tinybase/tinybaseStore';

export const useCurrentUser = () => useAppStore(({ user }) => user);

export const useRoleInformation = () => {
  const { roles } = useCurrentUser() || {};

  return useMemo(() => {
    if (!roles) {
      return {};
    }
    const isAdmin = roles.includes('Admin');
    const isNeighbourhoodManager = isAdmin || roles.includes('Neighbourhood_Manager');
    const isNeighbourhood = isNeighbourhoodManager || roles.includes('Neighbourhood');
    const isPcfraManager = isAdmin || roles.includes('PCFRA_Manager');
    const isPcfra = isPcfraManager || roles.includes('PCFRA_Editor');

    return { isAdmin, isNeighbourhoodManager, isNeighbourhood, isPcfraManager, isPcfra };
  }, [roles]);
};

export const useGlobalStore = () => useTinybaseStore((state) => state.syncStores?.globalStore);

export const useUserStore = () => useTinybaseStore((state) => state.syncStores?.userStore);

export const useGlobalStoreSyncStatus = () => {
  const globalStoreSyncronizer = useGlobalStore()?.synchronizer;

  return useSynchronizerStatus(globalStoreSyncronizer);
};
